import {BaseService} from "@/core/services/BaseService";

class NotificationService extends BaseService<any> {
  endpoint = "/notification"
}

export default new NotificationService()